import {Component, OnInit} from '@angular/core';
import {DbActiveModal} from "../../../../../modules/modal/modal-ref";
import {Utils} from "../../../../../shared/utils/utils";

@Component({
    selector: 'db-update-plugins-dialog',
    templateUrl: './update-plugins-dialog.component.html',
    standalone: false,
    styleUrl: './update-plugins-dialog.component.scss'
})
export class UpdatePluginsDialogComponent implements OnInit {
  pluginsCount;
  themesCount;

  constructor(public activeDialog: DbActiveModal) {
  }

  ngOnInit() {
    if (this.pluginsCount) {
      this.pluginsCount = Utils.wordByCount("plugin", this.pluginsCount);
    }
    if (this.themesCount) {
      this.themesCount = Utils.wordByCount("theme", this.themesCount);
    }
  }
}

